import React, { useEffect } from "react";
import AppHeader from "../components/reusable/header";
import Footer from "../components/reusable/footer";
import {
  LegalMainDiv,
  LegalHeroSection,
  LegalContent
} from "../styles/legal";

const RefundPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalMainDiv>
      <AppHeader
        hideContact={false}
        logo={"/images/sixthWhiteIcon.png"}
        top="0.5rem"
        width="10rem"
        mobileWidth="8rem"
      />

      <LegalHeroSection>
        <h1>Refund Policy</h1>
        <p>Last updated: July 15, 2026</p>
      </LegalHeroSection>

      <LegalContent>
        <p>
          This Refund Policy applies to all purchases of Sixth products and subscriptions made from SixHq Inc. ("Sixth," "we," "us," or "our"). It forms part of, and should be read together with, our Terms of Service.
        </p>

        <h2>1. Our Approach to Refunds</h2>
        <p>
          We're committed to offering the most affordable AI experience out there — at prices up to 10x cheaper than other providers, while delivering the same cutting-edge models. That means we absorb significant costs on every subscription so you don't have to. Because of this, refunds are reviewed on a case-by-case basis and eligibility is determined by your usage during the billing period.
        </p>

        <h2>2. Subscription Plans</h2>
        <p>
          If you believe you qualify for a refund on a subscription payment, reach out to <a href="mailto:ope@trysixth.com">ope@trysixth.com</a> and we'll be happy to take a look. Eligibility is determined by your usage of the service during the billing period in question. You can cancel your subscription at any time to avoid future charges; cancellation stops the next renewal and you keep access for the remainder of the period you've already paid for.
        </p>

        <h2>3. How to Request a Refund</h2>
        <p>
          Email us at <a href="mailto:ope@trysixth.com">ope@trysixth.com</a> from the email address associated with your Sixth account, and include:
        </p>
        <ul>
          <li>The email address on your Sixth account.</li>
          <li>The date and amount of the charge.</li>
          <li>A short description of why you're requesting a refund.</li>
        </ul>
        <p>
          We review every request and typically respond within a few business days. Approved refunds are returned to your original payment method.
        </p>

        <h2>4. Contact Us</h2>
        <p>
          If you have any questions about this Refund Policy, please contact us at <a href="mailto:ope@trysixth.com">ope@trysixth.com</a>.
        </p>
      </LegalContent>

      <Footer />
    </LegalMainDiv>
  );
};

export default RefundPolicy;
